import React, { forwardRef } from "react";
import moment from "moment";
import { startOfMonth, startOfWeek, addDays, addWeeks, isSameDay } from "date-fns";
import classNames from "classnames";
import { ArrowForwardIos, ArrowBackIos } from "../../icons";
import { onEnter } from "../../helpers";
import { isWithinRange } from "./utils";
function getIsWithinRangeFromStartAndEndDates(_ref) {
  var startDay = _ref.startDay,
    endDate = _ref.endDay,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate;
  var shouldCheck = !isWithinRange(startDay, minDate, maxDate) || !isWithinRange(endDate, minDate, maxDate);
  return function (date) {
    if (shouldCheck) return isWithinRange(date, minDate, maxDate);
    return true;
  };
}
var DAYS_IN_WEEK = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export var CalendarDisplay = /*#__PURE__*/forwardRef(function (props, ref) {
  function renderDays() {
    var month = props.date.getMonth();
    var MONDAY = 1;
    var startDay = startOfWeek(startOfMonth(props.date), {
      weekStartsOn: MONDAY
    });
    var WEEKS_TO_DISPLAY = 6;
    var endDay = addWeeks(startDay, WEEKS_TO_DISPLAY);
    var today = new Date();
    var isWithinRange = getIsWithinRangeFromStartAndEndDates({
      startDay: startDay,
      endDay: endDay,
      minDate: props.minDate,
      maxDate: props.maxDate
    });
    var days = [];
    var currDay = new Date(startDay);
    var _loop = function _loop() {
      var day = new Date(currDay);
      var DAYS_TO_ADD = 1;
      currDay = addDays(currDay, DAYS_TO_ADD);
      var isEnabled = isWithinRange(day);
      var onClick = function onClick() {
        if (!isEnabled) return false;
        props.onChange(day);
      };
      days.push(/*#__PURE__*/React.createElement("div", {
        key: day.getTime(),
        role: "button",
        tabIndex: -1,
        "aria-disabled": !isEnabled,
        className: classNames("tui-date-picker__calendar-display__day", {
          "tui-date-picker__calendar-display__day--other-month": month !== day.getMonth(),
          "tui-date-picker__calendar-display__day--current": isSameDay(day, props.selectedDate),
          "tui-date-picker__calendar-display__day--today": isSameDay(day, today)
        }),
        onClick: onClick,
        onKeyPress: onEnter(onClick)
      }, day.getDate()));
    };
    while (currDay < endDay) {
      _loop();
    }
    return days;
  }
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    "aria-hidden": !props.show,
    tabIndex: -1,
    ref: ref,
    className: "tui-date-picker__calendar-display ".concat(props.alwaysShowCalendar ? "tui-date-picker__calendar-display--inline-cal" : ""),
    style: {
      display: props.show ? undefined : "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__date"
  }, moment(props.date).format("MMMM YYYY")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    type: "button",
    "aria-label": "Previous month",
    onClick: props.prevMonth
  }, /*#__PURE__*/React.createElement(ArrowBackIos, null)), /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    type: "button",
    "aria-label": "Next month",
    onClick: props.nextMonth
  }, /*#__PURE__*/React.createElement(ArrowForwardIos, null)))), /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__calendar-display__days"
  }, DAYS_IN_WEEK.map(function (day) {
    return /*#__PURE__*/React.createElement("span", {
      className: "tui-date-picker__calendar-display__day tui-date-picker__calendar-display__dow",
      key: day
    }, day[0]);
  }), renderDays()));
});
//# sourceMappingURL=CalendarDisplay.js.map